import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/AuthContext";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function RegisterPage() {
  const { register, startGoogleAuth } = useAuth();
  const [form, setForm] = useState({ name: "", email: "", password: "", phone: "" });
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const r = await register(form);
    setLoading(false);
    if (r.ok) {
      toast.success("Cuenta creada");
      nav("/perfil");
    } else {
      toast.error(r.error || "No se pudo crear la cuenta");
    }
  };

  return (
    <div className="max-w-md mx-auto px-6 py-16" data-testid="register-page">
      <div className="text-xs font-mono uppercase text-neutral-500">/registro</div>
      <h1 className="font-display text-4xl tracking-tighter mt-1">Crea tu cuenta</h1>

      <form onSubmit={submit} className="mt-8 space-y-4">
        <div>
          <Label className="text-xs font-mono uppercase">Nombre</Label>
          <Input required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })}
                 className="rounded-none mt-2 h-11" data-testid="register-name" />
        </div>
        <div>
          <Label className="text-xs font-mono uppercase">Correo</Label>
          <Input type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })}
                 className="rounded-none mt-2 h-11" data-testid="register-email" />
        </div>
        <div>
          <Label className="text-xs font-mono uppercase">Teléfono</Label>
          <Input value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })}
                 className="rounded-none mt-2 h-11" data-testid="register-phone" />
        </div>
        <div>
          <Label className="text-xs font-mono uppercase">Contraseña</Label>
          <Input type="password" required minLength={6} value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })}
                 className="rounded-none mt-2 h-11" data-testid="register-password" />
        </div>
        <Button type="submit" disabled={loading} className="w-full h-12 brutal-btn bg-black hover:bg-[#FF3B30] text-white" data-testid="register-submit">
          {loading && <Loader2 className="w-4 h-4 mr-2 animate-spin" />}
          Crear cuenta
        </Button>
      </form>

      <div className="my-6 flex items-center gap-3">
        <div className="h-px bg-neutral-200 flex-1" />
        <span className="text-xs font-mono uppercase text-neutral-500">o</span>
        <div className="h-px bg-neutral-200 flex-1" />
      </div>

      <Button onClick={startGoogleAuth} variant="outline" className="w-full h-12 rounded-none border-black" data-testid="register-google">
        Continuar con Google
      </Button>

      <p className="text-sm text-center mt-6">
        ¿Ya tienes cuenta? <Link to="/login" className="font-medium underline">Entrar</Link>
      </p>
    </div>
  );
}
